export function getLastDayOfMonth(year:number, month:number) {
    let date = new Date(year, month, 0);
    return date.getDate();
  }